// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"453":"76fe4ff2","629":"76fe4ff2"}[chunkId] + ".chunk.css";
};